import {Box, Stack, Select, MenuItem } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import TextField from '@mui/material/TextField'
import { GridToolbarColumnsButton, GridToolbarFilterButton } from '@mui/x-data-grid'
import Close from 'mdi-material-ui/Close'
import Magnify from 'mdi-material-ui/Magnify'

const FindProductToolbar = props => {
  return (
    <Box
      sx={{
        p: 2,
        pb: 0,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
      }}
    >
      <Box>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
      </Box>
      <Stack display="flex" justifyContent="center" direction="row" spacing={4}>

        <Select
            onChange={props.onKeywordChange}
            value={props.keyword}
            size='small'
            variant='standard'
            sx={{ width: '120px', mr: 2, color: 'primary.main' }}
          >
            <MenuItem value={'name'}>제품명</MenuItem>
            <MenuItem value={'cat_id'}>Cat No</MenuItem>
            <MenuItem value={'pd_cas'}>CAS</MenuItem>
        </Select>

        <TextField
          variant='standard'
          value={props.value}
          onChange={props.onChange}
          placeholder='검색'
          InputProps={{
            startAdornment: <Magnify fontSize='small' />,
            endAdornment: (
              <IconButton size='small' title='Clear' aria-label='Clear' onClick={props.clearSearch}>
                <Close fontSize='small' />
              </IconButton>
            )
          }}
          sx={{
            width: {
              xs: 1,
              sm: 'auto'
            },
            m: theme => theme.spacing(1, 0.5, 1.5),
            '& .MuiSvgIcon-root': {
              mr: 0.5
            },
            '& .MuiInput-underline:before': {
              borderBottom: 1,
              borderColor: 'divider'
            }
          }}
        />
      </Stack>
    </Box>
  )
}

export default FindProductToolbar
